(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-videos')) {
    customElements.define(
      'product-videos',
      class ProductVideos extends HTMLElement {
        connectedCallback() {
          this.selectors = {
            sliderWrapper: '.product-videos__items',
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            pagination: '.swiper-pagination',
          };
          this.classes = {
            grid: 'f-grid',
            swiper: 'swiper',
            swiperWrapper: 'swiper-wrapper',
          };

          this.sectionId = this.dataset.sectionId;
          this.section = this.closest(`.section-${this.sectionId}`);
          this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
          this.enableSlider = this.dataset.enableSlider === 'true';
          this.items = parseInt(this.dataset.items, 10) || 3;
          this.tabletItems = parseInt(this.dataset.tabletItems, 10) || 2;
          this.paginationType = this.dataset.paginationType || 'progressbar';
          this.sliderInstance = false;

          if (!this.enableSlider) return;

          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.onchange = this.init.bind(this);
          this.init();
        }

        init() {
          if (FoxTheme.config.mqlMobile) {
            this.destroySlider();
          } else {
            this.initSlider();
          }
        }

        initSlider() {
          if (typeof this.sliderInstance === 'object' || !this.sliderWrapper) return;

          const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
          const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 0;

          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);

          this.sliderInstance = new window.FoxTheme.Carousel(
            this,
            {
              slidesPerView: 2,
              spaceBetween: spaceBetween,
              navigation: {
                nextEl: this.section.querySelector(this.selectors.nextEl),
                prevEl: this.section.querySelector(this.selectors.prevEl),
              },
              pagination: {
                el: this.section.querySelector(this.selectors.pagination),
                type: this.paginationType,
              },
              breakpoints: {
                768: {
                  slidesPerView: this.tabletItems,
                },
                1024: {
                  slidesPerView: this.items,
                },
              },
              loop: false,
              threshold: 2,
              watchSlidesProgress: true,
              mousewheel: {
                enabled: true,
                forceToAxis: true,
              },
            },
            [FoxTheme.Swiper.Mousewheel]
          );
          this.sliderInstance.init();
        }

        destroySlider() {
          this.classList.remove(this.classes.swiper);
          this.sliderWrapper?.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper?.classList.add(this.classes.grid);

          if (typeof this.sliderInstance !== 'object') return;

          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
